// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ng/styles/" + chunkId + "-" + {"193":"ceea63570f61121c91e8","540":"18a786552a77c1cc0426","920":"ed6df80084c92780ece9"}[chunkId] + ".css";
};